import {
  Box,
  List,
  Drawer,
  Button,
  Dialog,
  Typography,
  ListSubheader,
  DialogActions,
  DialogContent,
} from "@mui/material";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import { ExitToApp as ExitToAppIcon } from "@mui/icons-material";
import APB_LOGO from "../../../assets/AcrossLogo.png";
import {
  useNavbarData,
  DEALER_SECTIONS,
  Transition,
  renderNavItems,
} from "./navbarData";
import "./index.scss";

const NavBar = ({ onMobileClose, openMobile }) => {
  const {
    location,
    isLogout,
    handleLogoutOpen,
    handleLogoutClose,
    handleLogoutConfirm,
  } = useNavbarData({ onMobileClose, openMobile });

  const content = (
    <Box
      className={`navbar__content ${
        openMobile ? "navbar__content--mobile" : ""
      }`}
    >
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box className="navbar__menu-container">
          <Box className="navbar__side-menu">
            <Box
              className="navbar__logo-mobile"
              sx={{ display: { xs: "block", md: "none" } }}
            >
              <img alt="Logo" src={APB_LOGO} />
            </Box>

            {DEALER_SECTIONS?.map((section, i) => (
              <List
                key={`menu${i}`}
                subheader={
                  <ListSubheader disableGutters disableSticky>
                    {section.subheader}
                  </ListSubheader>
                }
              >
                {renderNavItems({
                  items: section.items,
                  pathname: location.pathname,
                })}
              </List>
            ))}
          </Box>
        </Box>

        <Box className="navbar__logout-container">
          <Button onClick={handleLogoutOpen} className="navbar__logout-button">
            <ExitToAppIcon className="navbar__logout-icon" />
            &nbsp;
            <Typography variant="body" className="navbar__logout-text">
              Logout
            </Typography>
          </Button>
        </Box>
      </PerfectScrollbar>

      {isLogout && (
        <Dialog
          fullWidth
          maxWidth="xs"
          open={isLogout}
          className="navbar__dialog"
          TransitionComponent={Transition}
          onClose={(_, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              return;
            }
            handleLogoutClose();
          }}
          slotProps={{
            backdrop: {
              style: { pointerEvents: "none" },
            },
          }}
        >
          <Box className="navbar__dialog-content">
            <DialogContent>
              <Box className="navbar__dialog-title">
                <Typography variant="h6" className="navbar__dialog-heading">
                  Logout
                </Typography>
                <Typography variant="body2" className="navbar__dialog-text">
                  Are you sure you want to logout?
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions className="navbar__dialog-actions">
              <Button
                type="submit"
                variant="contained"
                className="navbar__button navbar__button--confirm"
                onClick={handleLogoutConfirm}
              >
                Confirm
              </Button>
              <Button
                type="submit"
                variant="contained"
                className="navbar__button navbar__button--cancel"
                onClick={handleLogoutClose}
              >
                Cancel
              </Button>
            </DialogActions>
          </Box>
        </Dialog>
      )}
    </Box>
  );

  return (
    <>
      <Drawer
        anchor="left"
        open={openMobile}
        variant="temporary"
        onClose={onMobileClose}
        className="navbar__drawer navbar__drawer--mobile"
        sx={{ display: { xs: "block", lg: "none" } }}
      >
        <Box className="navbar__drawer-header">
          <img
            alt="Logo"
            className="navbar__drawer-logo"
            src={require("../../../assets/AirtelPaymentBank.png")}
          />
          <Button onClick={onMobileClose} className="navbar__close-button">
            X
          </Button>
        </Box>
        <Box className="navbar__drawer-content">{content}</Box>
      </Drawer>

      <Drawer
        open
        anchor="left"
        variant="persistent"
        className="navbar__drawer navbar__drawer--desktop"
        sx={{ display: { xs: "none", lg: "block" } }}
      >
        {content}
      </Drawer>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
